import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { ExpiringPsrItem } from './ExpiringPsrItem';
import type { PsrPreferencesType } from '../psr-types';

export const testId = 'expiringPsrListTestId';

type ExpiringPsrListProps = {
  psr?: PsrPreferencesType[];
};

export const ExpiringPsrList = ({ psr = [] }: ExpiringPsrListProps) => {
  return (
    <div data-testid={testId}>
      <NsColumn>
        {psr.map((psrItem) => (
          <ExpiringPsrItem {...psrItem} key={psrItem.code} />
        ))}
      </NsColumn>
    </div>
  );
};
